import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  min-height: 500px;
  text-align: center;
  animation: ${fadeIn} 0.5s ease-out;

  @media (max-width: 768px) {
    padding: 60px 20px;
    min-height: 400px;
  }
`;

export const EmptyStateIconWrapper = styled.div<{ $isError?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 24px;
  background: ${({ theme, $isError }) => {
    if ($isError) {
      return theme.mode === 'dark'
        ? 'rgba(239, 68, 68, 0.1)'
        : 'rgba(239, 68, 68, 0.08)';
    }
    return theme.mode === 'dark'
      ? 'rgba(224, 123, 45, 0.1)'
      : 'rgba(224, 123, 45, 0.08)';
  }};
  color: ${({ theme, $isError }) => ($isError ? '#ef4444' : theme.colors.primary[500])};
  margin-bottom: 32px;
  border: 1px solid ${({ theme, $isError }) => {
    if ($isError) {
      return theme.mode === 'dark'
        ? 'rgba(239, 68, 68, 0.2)'
        : 'rgba(239, 68, 68, 0.15)';
    }
    return theme.mode === 'dark'
      ? 'rgba(224, 123, 45, 0.2)'
      : 'rgba(224, 123, 45, 0.15)';
  }};

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin-bottom: 24px;

    svg {
      width: 48px;
      height: 48px;
    }
  }
`;

export const EmptyStateTitle = styled.h3`
  font-size: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 12px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const EmptyStateDescription = styled.p`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.6;
  max-width: 500px;
  margin: 0 0 32px 0;

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 100%;
    margin: 0 0 28px 0;
  }
`;

export const EmptyStateActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const EmptyStateActionLink = styled.a<{ $disabled?: boolean }>`
  font-size: 15px;
  font-weight: 500;
  color: #E07B2D;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  transition: all 0.2s ease;
  text-decoration: none;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  border: 1px solid #E07B2D;
  padding: 10px 20px;
  border-radius: 6px;
  display: inline-block;

  &:hover {
    background: rgba(224, 123, 45, 0.08);
    text-decoration: none;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 9px 18px;
  }
`;

export const EmptyStateSvgWrapper = styled.div<{ $isError?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: ${({ theme, $isError }) => {
    if ($isError) return '#ef4444';
    return theme.mode === 'dark' ? '#6b7280' : '#9ca3af';
  }};

  svg {
    width: auto;
    height: 125px;
  }

  @media (max-width: 768px) {
    margin-bottom: 20px;

    svg {
      height: 100px;
    }
  }
`;

export const EmptyStateFooterLink = styled.p`
  display: none;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 40px;
  text-align: center;

  button {
    color: #E07B2D;
    background: none;
    border: none;
    padding: 0;
    font-size: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: underline;

    &:hover {
      color: #c96a24;
    }
  }

  @media (max-width: 768px) {
    font-size: 13px;
    margin-top: 32px;
  }
`;
